import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { APP_PATHS } from '../constants/app-routes';
import { USER_ROLES } from '../constants/roles';
import { AuthService } from '../services/auth.service';

export const clientOwnerGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.user()?.role === USER_ROLES.clientOwner
    ? true
    : router.createUrlTree([APP_PATHS.fieldDashboard]);
};
